import React from 'react';
import { StyleSheet, View } from 'react-native';
import Images from '../../constants/Images';
import { Color, CommonProperties, CommonStyles } from '../../styles';
import Avatar from '../Avatar';
import BaseText from '../BaseText';
import Icon from '../Icon';
import RowView from '../RowView';

const SpeakerCard = ({ speaker }) => {
  return (
    <RowView style={styles.container}>
      <Icon name="chevronLeft" style={CommonStyles.h1} color={Color.primary} />
      <View style={styles.person}>
        <Avatar
          source={
            speaker.image
              ? {
                  uri: speaker.image,
                }
              : Images.default
          }
          size={120}
          noBorder={true}
          style={CommonStyles.mb3}
        />
        <BaseText style={CommonStyles.h2}>{speaker.name}</BaseText>
        <BaseText style={styles.title}>{speaker.title}</BaseText>
        <BaseText style={styles.bio}>{speaker.bio}</BaseText>
      </View>
      <Icon name="chevronRight" style={CommonStyles.h1} color={Color.primary} />
    </RowView>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    flex: 1,
  },
  person: {
    flex: 1,
    alignItems: 'center',
  },
  title: {
    color: Color.grayText,
    ...CommonProperties.py2,
    ...CommonProperties.h4,
    ...CommonProperties.fontItalic,
  },
  bio: {
    width: '60%',
    textAlign: 'center',
    ...CommonProperties.h4,
  },
});

export default SpeakerCard;
